import React, { useEffect, useState, useRef } from 'react';
import { X, Printer } from 'lucide-react';

interface HelpDocModalProps {
  onClose: () => void;
}

export const HelpDocModal: React.FC<HelpDocModalProps> = ({ onClose }) => {
  const [htmlContent, setHtmlContent] = useState<string>('');
  const [loading, setLoading] = useState(true);
  const iframeRef = useRef<HTMLIFrameElement>(null);

  useEffect(() => {
    fetch('/formules-plateforme.html')
      .then((res) => res.text())
      .then((html) => {
        setHtmlContent(html);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  useEffect(() => {
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleKey);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', handleKey);
      document.body.style.overflow = '';
    };
  }, [onClose]);

  const handlePrint = () => {
    if (iframeRef.current?.contentWindow) {
      iframeRef.current.contentWindow.print();
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex flex-col" style={{ background: 'rgba(0,0,0,0.6)' }}>
      <div className="flex items-center justify-between px-5 py-3 bg-white border-b border-neutral-200 shadow-sm flex-shrink-0">
        <div className="flex items-center gap-3">
          <div className="w-2 h-6 rounded-full" style={{ background: '#15A759' }} />
          <span className="font-semibold text-neutral-800 text-sm">
            Formules &amp; Logiques de la Plateforme
          </span>
          <span className="text-xs text-neutral-400 font-medium px-2 py-0.5 bg-neutral-100 rounded-full">
            Usage interne — Confidentiel
          </span>
        </div>
        <div className="flex items-center gap-2">
          <button
            onClick={handlePrint}
            disabled={loading}
            className="flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium text-neutral-600 bg-neutral-100 hover:bg-neutral-200 rounded-md transition-colors disabled:opacity-40"
          >
            <Printer className="w-3.5 h-3.5" />
            Imprimer
          </button>
          <button
            onClick={onClose}
            className="flex items-center justify-center w-8 h-8 rounded-md text-neutral-500 hover:text-neutral-800 hover:bg-neutral-100 transition-colors"
            title="Fermer"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      </div>

      <div className="flex-1 overflow-hidden bg-white">
        {loading ? (
          <div className="flex items-center justify-center h-full text-neutral-400 text-sm">
            Chargement…
          </div>
        ) : (
          <iframe
            ref={iframeRef}
            srcDoc={htmlContent}
            className="w-full h-full border-0"
            title="Formules et logiques – Plateforme Sun Is Up"
            sandbox="allow-same-origin allow-scripts allow-popups allow-modals"
          />
        )}
      </div>
    </div>
  );
};
